import React from 'react';
import { startSteps } from '../data/offer';
export function GetStarted() {
  return <section className="border-t border-white/10 bg-navy-900" data-id="element-87" data-mp="2hnpf3k73rejw">
      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-16" data-id="element-88" data-mp="2hq25mlqxex8k">
        <h2 className="max-w-xl text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-89" data-mp="2mntv7943m79l">
          Get Started in Three Simple Steps
        </h2>

        <ol className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-90" data-mp="1tywo825c7ww5">
          {startSteps.map(step => <li key={step.id} className="border-l-2 border-brand-emerald bg-navy-800 p-5" data-id="element-91" data-mp="1ywy9mtq8k8as">
              <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-92" data-mp="22xi5zv2zj7vv">
                {step.index}
              </p>
              <h3 className="mt-2.5 font-pixel text-[11px] uppercase leading-relaxed tracking-[0.08em] text-white" data-id="element-93" data-mp="1b7vh2qu2cv1i">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-300" data-id="element-94" data-mp="1f7nubguejpd7">
                {step.copy}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}